import {useSalesDashboardStore} from '../store/salesDashboardStore';

export function useSalesDashboard () {
  return useSalesDashboardStore();
}
